import { render } from "./Alert.vue?vue&type=template&id=cd58fa92"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v2/Modal/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd58fa92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd58fa92', __exports__)) {
    api.reload('cd58fa92', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=cd58fa92", () => {
    api.rerender('cd58fa92', render)
  })

}


export default __exports__